/**
 * Created by kimchangduk on 2017-05-20.
 */

import AppStoreLink from './AppStoreLink';
import PlayStoreLink from './PlayStoreLink';

export default {AppStoreLink, PlayStoreLink};